var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center align-items-center" },
    [
      _c(
        "CheckPermission",
        { attrs: { permission: "ED018" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value: "modal-details-" + _vm.file.idAprobacion,
                  expression: "`modal-details-${file.idAprobacion}`"
                }
              ],
              staticClass: "btn-icon rounded-circle p-3",
              attrs: { "data-cy": "details", variant: "secondary", size: "sm" },
              on: {
                click: function($event) {
                  return _vm.onOptionGetGeneralDetailsFile(_vm.file)
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: "Desplegar acciones",
              expression: "'Desplegar acciones'"
            }
          ]
        },
        [
          _c(
            "b-dropdown",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED096",
                  expression: "'ED096'"
                }
              ],
              attrs: { variant: "link", "no-caret": "", right: "" },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function() {
                    return [
                      _c("feather-icon", {
                        staticClass: "align-middle text-body",
                        attrs: {
                          "data-cy": "gear-button",
                          width: "24px",
                          height: "24px",
                          icon: "SettingsIcon"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "CheckPermission",
                { attrs: { permission: "ED016" } },
                [
                  _vm.isDraft && !_vm.isInputDocForm
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "continue-draft" },
                          on: {
                            click: function($event) {
                              return _vm.openDraft()
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "query_builder" } }),
                          _vm._v(" Continuar borrador ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isDraft && !_vm.isInputDocForm
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "delete-draft" },
                          on: {
                            click: function($event) {
                              return _vm.deleteDraft(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "delete" } }),
                          _vm._v(" Descartar borrador ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isDraft && _vm.isInputDocForm
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "continue-form" },
                          on: {
                            click: function($event) {
                              return _vm.openInputFormDraft()
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "query_builder" } }),
                          _vm._v(" Continuar ingreso ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED140" } },
                [
                  _vm.isInputDocForm &&
                  (_vm.onIncompleteFiles || _vm.onGeneralFiles) &&
                  _vm.canEditFile
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "Edit" },
                          on: {
                            click: function($event) {
                              return _vm.openInputDocForm()
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "edit" } }),
                          _vm._v(" Editar ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED146" } },
                [
                  _vm.canEditFileWizard
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "edit-file" },
                          on: {
                            click: function($event) {
                              return _vm.onEditFile()
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "edit" } }),
                          _vm._v(" Editar Exp. ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED017" } },
                [
                  !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "binnacle" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionBinnacleFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "list" } }),
                          _vm._v(" Bitácora ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              !_vm.isAguasAndinas
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED039" } },
                    [
                      !_vm.isDraft &&
                      _vm.onPendingFiles &&
                      _vm.isAssigned &&
                      !_vm.isProcessed &&
                      !_vm.isCancelled &&
                      !_vm.isShared
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "answer-option" },
                              on: {
                                click: function($event) {
                                  return _vm.onAnswerFile(_vm.file)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "storage" } }),
                              _vm._v(" Responder ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED040" } },
                [
                  !_vm.isDraft &&
                  _vm.onPendingFiles &&
                  _vm.isAssigned &&
                  _vm.file.solicitanteDocumentoId !== _vm.currentUserId &&
                  !_vm.isProcessed &&
                  !_vm.isCancelled &&
                  !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "return-file" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionReturnFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", {
                            attrs: { icon: "keyboard_backspace" }
                          }),
                          _vm._v(" Devolver expediente ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.isAguasAndinas
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED134" } },
                    [
                      !_vm.isDraft &&
                      _vm.onPendingFiles &&
                      _vm.isAssigned &&
                      !_vm.isProcessed &&
                      !_vm.isCancelled &&
                      !_vm.isShared &&
                      _vm.canRespond
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "answer" },
                              on: {
                                click: function($event) {
                                  return _vm.onResponseFile(_vm.file)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "storage" } }),
                              _vm._v(" Responder ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED026" } },
                [
                  !_vm.isDraft &&
                  _vm.onPendingFiles &&
                  !_vm.hasTwoRecipients &&
                  _vm.isAssigned &&
                  _vm.isResponsible &&
                  !_vm.isProcessed &&
                  !_vm.isCancelled &&
                  !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "send-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionSendFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "call_made" } }),
                          _vm._v(" Enviar documento ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "DNT58" } },
                [
                  _vm.onGeneralFiles || _vm.onPendingFiles
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "notify-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionNotifyFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "notifications" } }),
                          _vm._v(" Notificar a usuarios ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED231" } },
                [
                  _vm.isAguasAndinas &&
                  (!_vm.file.enviadoOpenText ||
                    _vm.file.enviadoOpenText === "N")
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "mark-sent-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionMarkSentFile(
                                _vm.file,
                                "enviar"
                              )
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "trending_up" } }),
                          _vm._v(" Marcar enviado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAguasAndinas &&
                  _vm.file.enviadoOpenText && _vm.file.enviadoOpenText === "Y"
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "mark-unsent-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionMarkSentFile(
                                _vm.file,
                                "no-enviar"
                              )
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "trending_up" } }),
                          _vm._v(" Marcar no enviado ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED024" } },
                [
                  !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "participants" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionGetParticipants(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "group" } }),
                          _vm._v(" Participantes ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED018" } },
                [
                  !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "target-process" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionTimelineFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "all_inbox" } }),
                          _vm._v(" Proceso Destinos ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED025" } },
                [
                  !_vm.isDraft &&
                  _vm.onPendingFiles &&
                  _vm.isAssigned &&
                  _vm.isResponsible &&
                  !_vm.isProcessed &&
                  !_vm.isCancelled &&
                  !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "comments" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionGetComments(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "chat" } }),
                          _vm._v(" Comentarios ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              !_vm.isShared
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "see-reference" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionReferencesFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "device_hub" } }),
                      _vm._v(" Ver Referencias ")
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED020" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "download-file" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionDownloadAttachments(_vm.file)
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "save_alt" } }),
                      _vm._v(" Descargar expediente ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED021" } },
                [
                  (!_vm.isDraft &&
                    _vm.onPendingFiles &&
                    !_vm.isAssigned &&
                    !_vm.isProcessed &&
                    !_vm.isCancelled &&
                    !_vm.isShared) ||
                  _vm.canAssignMeFile
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "assign-me-file" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionAssignFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "how_to_reg" } }),
                          _vm._v(" Asignarme expediente ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.isAguasAndinas
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED150" } },
                    [
                      !_vm.isDraft &&
                      _vm.onPendingFiles &&
                      _vm.isAssigned &&
                      _vm.isResponsible &&
                      !_vm.isProcessed &&
                      !_vm.isCancelled &&
                      !_vm.isShared &&
                      _vm.isResponse
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "see-answer" },
                              on: {
                                click: function($event) {
                                  return _vm.onViewResponseFile(_vm.file)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "storage" } }),
                              _vm._v(" Ver Respuesta ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.verifyUserPermission
                ? _c(
                    "b-dropdown-item",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED022|ED138",
                          expression: "'ED022|ED138'"
                        }
                      ],
                      attrs: { "data-cy": "cancel-file" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionCancelFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "clear" } }),
                      _vm._v(" Anular expediente ")
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED023" } },
                [
                  _vm.verifyProcessPermission
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "finalize-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionProcessFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "move_to_inbox" } }),
                          _vm._v(" Finalizar documento ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED098" } },
                [
                  _vm.isArchivable
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "file-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionArchiveFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "move_to_inbox" } }),
                          _vm._v(" Archivar documento ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.canRecover
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED232" } },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "rescue-file" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionRecoverFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "RotateCcwIcon" }
                          }),
                          _c("span", [_vm._v(" Rescatar expediente ")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED099" } },
                [
                  _vm.watchProcessFile
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "see-process-record" },
                          on: {
                            click: function($event) {
                              return _vm.getProcessDocument(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "description" } }),
                          _vm._v(" Ver acta de proceso ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.canSendToFlow
                ? _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "send-to-flow" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionSendToFlowFile(_vm.file)
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "call_split" } }),
                      _vm._v(" Enviar a flujo ")
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED113" } },
                [
                  _vm.isNumbered
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "send-to-comptroller" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionSendControlFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "exit_to_app" } }),
                          _vm._v(" Enviar a contraloría ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED114" } },
                [
                  _vm.isOnControl
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "Received-from-comptroller" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionControlReceived(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "gavel" } }),
                          _vm._v(" Recibido de contraloría ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED058" } },
                [
                  _vm.canGoKanban
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "activity-board" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionOpenActivityBoard(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "developer_board" } }),
                          _vm._v(" Actividades ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.isAguasAndinas
                ? _c(
                    "CheckPermission",
                    { attrs: { permission: "ED139" } },
                    [
                      !_vm.isDraft &&
                      _vm.onPendingFiles &&
                      _vm.isAssigned &&
                      _vm.isResponsible &&
                      !_vm.isProcessed &&
                      !_vm.isCancelled &&
                      !_vm.isShared &&
                      _vm.isResponse
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "sign-response" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionSignAnswer(_vm.file)
                                }
                              }
                            },
                            [
                              _c("vs-icon", {
                                attrs: { icon: "assignment_turned_in" }
                              }),
                              _vm._v(" Firmar respuesta ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED027" } },
                [
                  !_vm.isDraft && !_vm.isShared
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "help-ticket" },
                          on: {
                            click: function($event) {
                              return _vm.onTicketFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "help" } }),
                          _vm._v(" Ticket de ayuda ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED127" } },
                [
                  _vm.onEnteredFiles
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "upload-document" },
                          on: {
                            click: function($event) {
                              return _vm.onOptionGetGeneralDetailsFile(
                                _vm.file,
                                "loadDocuments"
                              )
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "cloud_upload" } }),
                          _vm._v(" Cargar docs. ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED128" } },
                [
                  _vm.onIncompleteFiles
                    ? _c(
                        "b-dropdown-item",
                        { on: { click: _vm.completeMetadata } },
                        [
                          _c("vs-icon", {
                            attrs: {
                              icon: "edit",
                              "data-cy": "complete-information"
                            }
                          }),
                          _vm._v(" Completar información ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED115" } },
                [
                  _vm.canSendDocDigital
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "submit-doc-digital" },
                          on: {
                            click: function($event) {
                              return _vm.onSendDocDigital(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "edit" } }),
                          _vm._v(" Enviar a DocDigital ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED274" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "update-privacy" },
                      on: {
                        click: function($event) {
                          return _vm.updatePrivacity(_vm.file)
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "edit" } }),
                      _vm._v(" Actualizar privacidad ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }